var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginNhanesPortalIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M13.5 22q-2.7 0-4.6-1.9T7 15.5v-.575q-2.15-.35-3.575-2.013T2 9V3h3V2h2v4H5V5H4v4q0 1.65 1.175 2.825T8 13t2.825-1.175T12 9V5h-1v1H9V2h2v1h3v6q0 2.25-1.425 3.912Q11.15 14.576 9 14.926v.575q0 1.875 1.313 3.188Q11.625 20 13.5 20t3.188-1.312T18 15.5v-1.675a2.9 2.9 0 0 1-1.437-1.075A2.9 2.9 0 0 1 16 11q0-1.25.875-2.125A2.9 2.9 0 0 1 19 8q1.25 0 2.125.875T22 11q0 .975-.562 1.75A2.9 2.9 0 0 1 20 13.825V15.5q0 2.7-1.9 4.6T13.5 22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M19 12q.424 0 .712-.287A.97.97 0 0 0 20 11a.97.97 0 0 0-.288-.713A.97.97 0 0 0 19 10a.97.97 0 0 0-.712.287A.97.97 0 0 0 18 11q0 .424.288.713.287.287.712.287"
}))));
export default SvgPluginNhanesPortalIcon;